<template>
	<v-tooltip :attach="overlayTarget" location="start" v-if="props.params.tooltip">
		<template v-slot:activator="{ props: activatorProps }">
			<span v-bind="activatorProps" @click.stop="props.params.onClick(props.params.key)">
				<v-icon class="grid-icon" :class="colorClass">{{ props.params.icon }}</v-icon>
			</span>
		</template>
		<span>{{ props.params.tooltip }}</span>
	</v-tooltip>
	<v-icon v-else class="grid-icon" :class="colorClass" @click="props.params.onClick(props.params.key)">{{ props.params.icon }}</v-icon>
</template>

<script setup>
import { inject, computed } from 'vue';

const props = defineProps({
	params: {
		required: true,
		type: Object,
		tooltip: String,
		icon: String,
		key: String,
		onClick: Function,
		color: String,
	},
});
const overlayTarget = inject('overlayTarget', null);
const colorClass = computed(() => (props.params.color ? `text-${props.params.color}` : null));
</script>

<style lang="scss">
.grid-icon {
	cursor: pointer;
}
</style>
